import type { ServerSummary } from "@woven/contracts";
import { Link } from "react-router";
import { StatusIndicator } from "../../components/ui/StatusIndicator";
import { statusTone } from "../../lib/serverStatus";
import { ServerCapacityMetric } from "./ServerCapacityMetric";
import { ServerMonitoring } from "./ServerMonitoring";

export function ServerOverviewCard({ server }: { server: ServerSummary }) {
  const provisioned = server.connection?.tokenStatus === "active" && !!server.connection.endpoint;
  return (
    <article className="panel server-card" aria-label={`${server.name} (${server.id})`}>
      <header className="server-card-head">
        <h2 className="panel-title">{server.name}</h2>
        <StatusIndicator tone={statusTone(server.status)} label={server.status} mono />
      </header>
      <dl className="server-card-metrics">
        <div>
          <dt>Product ID</dt>
          <dd className="cell-mono">{server.id}</dd>
        </div>

        <div>
          <dt>Capacity</dt>
          <dd>
            <ServerCapacityMetric server={server} />
          </dd>
        </div>

        <div>
          <dt>Endpoint</dt>
          <dd className="cell-mono">
            {provisioned ? server.connection?.endpoint : "Not provisioned"}
          </dd>
        </div>
        <div>
          <dt>Region</dt>
          <dd>{server.region}</dd>
        </div>
      </dl>
      <ServerMonitoring server={server} />
      <footer className="server-actions">
        <Link
          to={`/console/logs?serverId=${encodeURIComponent(server.id)}`}
          className="btn btn--ghost btn--sm"
        >
          View Logs
        </Link>
        <Link
          to={`/console/servers/${encodeURIComponent(server.id)}`}
          className="btn btn--primary btn--sm"
        >
          View Details
        </Link>
      </footer>
    </article>
  );
}
